import { Component } from 'react';
import { validator } from 'Helpers/validator';
import LoadingOverlay from 'react-loading-overlay';
import labeltop from 'Helpers/labelTop';
import { ModuleActions } from 'Constants/Modules.constants';
import { ReactComponent as ArrowDown } from 'assets/images/svg/arrow-icon.svg';

/**
 * @file Settings Component
 * User can view and update their settings
 * @module 5.Settings
 * @extends Component
 */
export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      mailDomain: '',
      adminUser: '',
      audioLimit: '',
      videoLimit: '',
      audioType: '',
      videoType: '',
      mailLogin: 'no',
      webLink: '',
      androidLink: '',
      iosLink: '',
    };
    this.validator = validator.getInstance();
  }

  /**
   * @event componentDidMount
   * @summary API call to fetch settings
   * @return {Object} return setting object
   */
  componentDidMount() {
    this.props.fetchsettings();
  }

  /**
   * @event getDerivedStateFromProps
   * @summary update the local setting state based on props
   * @return {Object|null } return setting state or null
   */

  static getDerivedStateFromProps(props, state) {
    const {
      id,
      mailDomain,
      adminUser,
      audioLimit,
      videoLimit,
      audioType,
      videoType,
      mailLogin,
      webLink,
      androidLink,
      iosLink,
    } = props;
    if (props.id !== state.id) {
      return {
        id,
        mailDomain,
        adminUser,
        audioLimit,
        videoLimit,
        mailLogin,
        audioType,
        videoType,
        webLink,
        androidLink,
        iosLink,
      };
    }
    return null;
  }
  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */
  validation = e => {
    const superparent = e.target.parentElement;
    !e.target.value && superparent.classList.remove('top');
    if (!e.target.dataset.validation && !e.target.dataset.check) {
      return;
    }
    const inputRules = e.target.dataset.validation.split(',');
    let elementObject = {
      formId: 'settingform',
      elementName: e.target.name,
      message: e.target.dataset.error,
      elementValue: e.target.value,
    };

    if (e.target.name == 'audioType') {
      const { audioLimit, audioType } = this.state;
      elementObject = {
        ...elementObject,
        updateMessage: 'Enter valid audio limit',
        validateInput: [ audioLimit, audioType ]
      };
    }
    if (e.target.name == 'videoType') {
      const { videoLimit, videoType } = this.state;
      elementObject = {
        ...elementObject,
        updateMessage: 'Enter valid video limit',
        validateInput: [ videoLimit, videoType ]
      };
    }
    this.validator.validate(elementObject, inputRules);
  };

  /**
   * @method handleChange
   * @summary set the state based on input type change action
   * @param {event} event - React onChange event
   * @return {Object} return setting object
   */

  handleOnchange = event => {
    event.persist();
    this.setState(
      {
        [ event.target.name ]: event.target.value
      },
      () => (!event.target.value ? this.labeltop(event) : null)
    );
  };
  handleTypechange = event => {
    this.setState(
      {
        [ event.target.name ]: event.target.value
      }
    );
  };
  handleLimitOnchange = event => {
    event.persist();
    const val = event.target.value.split(''); 
    if(val.length > 6){
      const slicedVal= val.slice(0, 6)
      const filteredVal = slicedVal.join('')
      this.setState(
        {
          [ event.target.name ]: filteredVal
        },
        () => (!filteredVal ? this.labeltop(event) : null)
      );
    }else{
    this.setState(
      {
        [ event.target.name ]: parseInt(event.target.value)
      },
      () => (!event.target.value ? this.labeltop(event) : null)
    )
    }
  };
  /**
   * @method handleValidSubmit
   * @summary submit the setting form after the validation
   * @param {event} event - React onSubmit event
   * @return {Object} return setting object
   */
  handleValidSubmit = event => {
    event.preventDefault();
    if( (this.validator.checkBeforeSubmit(event.target.id) ||
      this.state.audioType === '') &&  (this.validator.checkBeforeSubmit(event.target.id) || this.state.videoType === '')){
        const e = new Event('blur');
        const element1 = document.getElementById('audioType');
        element1.setAttribute('data-check', true);
        element1.dispatchEvent(e);
        element1.removeAttribute('data-check');
        const element2 = document.getElementById('videoType');
        element2.setAttribute('data-check', true);
        element2.dispatchEvent(e);
        element2.removeAttribute('data-check');
        return;
      }else if (
        this.validator.checkBeforeSubmit(event.target.id) ||
        this.state.audioType === ''
      ) {
        const e = new Event('blur');
        const element = document.getElementById('audioType');
        element.setAttribute('data-check', true);
        element.dispatchEvent(e);
        element.removeAttribute('data-check');
        return;
      }
      else if (
        this.validator.checkBeforeSubmit(event.target.id) ||
        this.state.videoType === ''
      ) {
        const ele = new Event('blur');
        const elementVideo = document.getElementById('videoType');
        elementVideo.setAttribute('data-check', true);
        elementVideo.dispatchEvent(ele);
        elementVideo.removeAttribute('data-check');
        return;
      } 
    if (event.target.id && !this.validator.checkBeforeSubmit(event.target.id)) {
      const {
        id,
        mailDomain,
        adminUser,
        audioLimit,
        videoLimit,
        mailLogin,
        audioType,
        videoType,
        webLink,
        androidLink,
        iosLink,
      } = this.state;
      this.props.updatesettings({
        id,
        mailDomain,
        adminUser,
        audioLimit,
        videoLimit,
        mailLogin,
        audioType,
        videoType,
        webLink,
        androidLink,
        iosLink,
      });
  }
  };
  labeltop(e) {
    const superparent = e.target.parentElement;
    superparent.classList.add('top');
  }
  handleType = event => {
    event.preventDefault();
    this.setState({ [ event.target.name ]: event.target.value });
  };
  isNumber = (evt) =>  {
    var iKeyCode = (evt.which) ? evt.which : evt.keyCode
    if (iKeyCode >= 48 && iKeyCode <= 57){
      return true;
    } else {
      evt.preventDefault();
        return false;
    }

} 
  render() {
    const {
      mailDomain,
      adminUser,
      audioLimit,
      videoLimit,
      audioType,
      videoType,
      webLink,
      androidLink,
      iosLink,
    } = this.state;
    const { loading,profile } = this.props;
    const Permission = profile && profile[ 'Settings' ] && profile[ 'Settings' ][ ModuleActions.edit ];
    return (
      <>
      <div className='pageContainer_inner'>
        <div className='settings myprofile'>
          <div class="heading-block gap-10"><div className='block_flex'><h4>Settings</h4></div></div>
            <div className={ Permission ? 'main-block loading-parent p-0' :'main-block loading-parent settings-container p-0' }>
              <LoadingOverlay
              active={ loading }
              spinner
              styles={ {
              wrapper: {
              width: '100%',
              textAlign: '-webkit-center'
              }
              } }
              text='Please wait...'
              ></LoadingOverlay>
              {/* <h3>General Settings</h3> */}
            <form
              id='settingform'
              onSubmit={ this.handleValidSubmit }
              noValidate
              autoComplete='off'
              >
              <div className='pageContent'>
                <div className='row'>
                  <div className='ctInputField'>
                    <label>Admin User<sup>*</sup></label>
                    <input
                    name='adminUser'
                    onBlur={ this.validation }
                    onChange={ this.handleOnchange }
                    data-validation={ [ 'adminuser' ] }
                    type='text'
                    maxLength='25'
                    onFocus={ labeltop }
                    value={ adminUser }
                    />
                  </div>
                  <div className='ctInputField'>
                    <label>Web App URL<sup>*</sup></label>
                    <input
                    name='webLink'
                    onBlur={ this.validation }
                    onChange={ this.handleOnchange }
                    data-validation={ [ 'url' ] }
                    type='text'
                    onFocus={ labeltop }
                    data-error='Please enter web app URL.'
                    value={ webLink }
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='ctInputField'>
                    <label>Android App URL<sup>*</sup></label>
                    <input
                    name='androidLink'
                    onBlur={ this.validation }
                    onChange={ this.handleOnchange }
                    data-validation={ [ 'url' ] }
                    type='text'
                    onFocus={ labeltop }
                    data-error='Please enter android app URL.'
                    value={ androidLink }
                    />
                  </div>
                  <div className='ctInputField'>
                    <label>iOS App URL<sup>*</sup></label>
                    <input
                    name='iosLink'
                    onBlur={ this.validation }
                    onChange={ this.handleOnchange }
                    data-validation={ [ 'url' ] }
                    type='text'
                    onFocus={ labeltop }
                    data-error='Please enter iOS app URL.'
                    value={ iosLink }
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='ctInputField'>
                    <label>Audio Limit<sup>*</sup></label>
                    <input
                    name='audioLimit'
                    onBlur={ this.validation }
                    data-validation={ [ 'greaterthanZero' ] }
                    onChange={ this.handleLimitOnchange }
                    type='number'
                    maxLength={ 1 }
                    onFocus={ labeltop }
                    value={ audioLimit }
                    onKeyPress={ (e) => { this.isNumber(e) } }
                    />

                    <div className='select_dwn_box_time'>
                      <select
                      className='time-format'
                      name='audioType'
                      value={ audioType }
                      data-check={ true }
                      onBlur={ this.validation }
                      onChange={ this.handleTypechange }
                      data-validation={ [ 'requiredformat' ] }
                      id='audioType'
                      >
                      <option value=''>Select</option>
                      <option value='sec'>Seconds</option>
                      <option value='min'>Minutes</option>
                      <option value='hrs'>Hour</option>
                      </select>
                      {/* <svg width="14" height="14" viewBox="0 0 14 14"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg> */}
                      {/* <svg  width="20" height="20" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg> */}
                      <ArrowDown/>
                      </div>
                  </div>
                  
                  <div className='ctInputField'>
                    <label>Video Limit<sup>*</sup></label>
                    <input
                    name='videoLimit'
                    onBlur={ this.validation }
                    data-validation={ [ 'greaterthanZero' ] }
                    onChange={ this.handleLimitOnchange }
                    type='number'
                    onFocus={ labeltop }
                    value={ videoLimit }
                    onKeyPress={ (e) => { this.isNumber(e) } }
                    />
                    <div className='select_dwn_box_time'>
                    <select
                    className='time-format'
                    name='videoType'
                    value={ videoType }
                    data-check={ true }
                    onBlur={ this.validation }
                    onChange={ this.handleTypechange }
                    data-validation={ [ 'requiredvideoformat' ] }
                    id='videoType'
                    >
                    <option value=''>Select</option>
                    <option value='sec'>Seconds</option>
                    <option value='min'>Minutes</option>
                    <option value='hrs'>Hour</option>
                    </select>
                    {/* <svg width="14" height="14" viewBox="0 0 14 14"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg> */}
                    {/* <svg  width="20" height="20" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg> */}
                    <ArrowDown/>
                    </div>
                  </div>
                </div>
              </div>
              <div className='pageContent_footer'>
                <div className='button_wrapper'>
                <button type='submit' className='btn btn_primary'>Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      </>
    );
  }
}
